export default {
  DpAssignmentCard: {
    started: 'Started',
    deleted: 'Sorry, the teacher deleted the assignment and it is no longer available'
  }
};